
<script>
import store from '../store/index.js';
import {forEach} from 'lodash';
import autoShowImg from '../../assets/promotion_1.png';
export default {
    data() {
        return {
			title: store.promotion.title,
			explainTitle: store.promotion.explainTitle,
			explainText: store.promotion.explainText,
			list: store.promotion.list,
			colors: [{
				backgroundImage: 'url('+require("../../assets/promotion_1.png")+')'
			},{
				backgroundImage: 'url('+require("../../assets/promotion_2.png")+')'
			},{
				backgroundImage: 'url('+require("../../assets/promotion_3.png")+')'
			},{
				backgroundImage: 'url('+require("../../assets/promotion_4.png")+')'
			},{
				backgroundImage: 'url('+require("../../assets/promotion_5.png")+')'
			}]
			
        }
	},
	computed: {
		doubleItemList() {
			const result = [];
			forEach(this.list, (item, index) => {
				const colorIndex = index % this.colors.length;
				result.push({
					...item,
					style: this.colors[colorIndex]
				});
			});
			return result;
		}
	}
}
</script>

<template>
    <div class="wrap">
        <div class="title">
        	{{title}}
			<i class="title-icon"></i>
        </div>
        <div class="main">
        	<div class="double-card" v-for="(item, index) in doubleItemList" :key="item.title">
				<div class="card" :style="item.style">
					<div class="card-title" :class="{'card-title-odd': index%2===0}" :style="item.titleStyle">{{item.title}}</div>
					<div class="card-text" v-html="item.text" :class="{'card-text-odd': index%2===0}"></div>
				</div>
        	</div>
        </div>
		<div class="explain">
			<p class="text">{{explainTitle}}:</p>
			<p class="text" v-html="explainText"></p>
		</div>
    </div>
</template>
<style lang="stylus" scoped>
.title
	margin 0.96rem 0 0
.wrap
	padding 0 0.32rem
	font-size 0
	text-align center
	overflow hidden
	.main
		display: inline-block;
		margin-right 0.48rem
		text-align center
		// 解决inline-block空白
		font-size 0
	.double-card
		margin-top 0.8125rem
		font-size 0
		.card
			position relative
			display inline-block
			margin-left 0.48rem;
			width 18.375rem
			height 4.1875rem
			vertical-align top
			border-radius 0.213rem
			color #fff
			background-size cover
			.card-title
				position absolute
				top -0.14rem
				left 0.56rem
				font-size 0.8rem
				text-align center
				width 3.25rem
				height 1.65rem
				line-height 1.65rem
				font-weight 800	
				border-radius 0.053rem 0.053rem 10px 10px
			.card-title-odd 
				right 0.47rem
				left auto
			.card-icon
				display block
				height 3.75rem
				width 3.75rem
				position absolute
				right 0.3125rem
				top 0.1875rem
				background: url('data:image/png;base64,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') no-repeat
				background-size cover
			
			.card-text
				font-size 0.64rem
				margin-top 1.9rem
				padding 0 9rem 0.53rem 0.53rem
				height 2.53rem
				line-height .9375rem
				text-align left
				box-sizing border-box
				background-size 100% 100%
				display flex
				align-items center
			.card-text-odd
				padding 0 0.53rem 0.53rem 5.7rem
				text-align right
	.double-card:nth-of-type(3),.double-card:nth-of-type(5) {
		.card{
			.card-text {
				padding 0 0.53rem 0.53rem 7.8rem
				text-align right
			}
		}
	}
	.double-card:nth-of-type(1){
		.card{
			.card-text{
				padding-left: 8.8rem;
			}
		}
	}
	.double-card:nth-of-type(3){
		.card{
			.card-text{
				padding-left: 11rem;
			}
		}
	}
	.double-card:nth-of-type(5){
		.card{
			.card-text{
				padding-left: 8.5rem;
			}
		}
	}
.explain
	border-top 2px solid #5A27AB
	border-bottom 2px solid #5A27AB
	width 18.375rem
	padding .5rem 0
	margin 0.8125rem auto
	.text
		text-align left
		font-size 0.5625rem
		font-family PingFangSC-Semibold,PingFang SC
		font-weight 600
		color #A974FF
		line-height 1.0625rem
		// font-size 0.75rem
		// transform-origin 0 0
		// transform scale(0.75)
		// margin-right -6rem

</style>